import Vue from 'vue'
import Vuex from 'vuex'
import {
  setToken,setUserId,setUserInfo,setConfig,getConfig,setCompany,getCompany
} from '@/utils/auth';
import {login,getGlobalConfig,getCompanyName,registerPcUser} from "@/api/login";
import { Message } from 'element-ui';
import router from '@/router';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {},
  mutations: {},
  actions: {
    // 登录
    Login({
      commit,
      dispatch
    }, userInfo) {
      const phone = userInfo.phone;
      const password = userInfo.password;
      const level = userInfo.level;
      return new Promise((resolve, reject) => {
        login({
          phone,
          password,
          level
        }).then(async res => {
          if (res.code == 200) {
            setToken(res.data.token);
            setUserId(res.data.user_id);
            setUserInfo(res.data);
            resolve({
              code: 200,
              msg: res.msg
            })
          }
          else {
            Message({ message: res.msg, type: 'error' })
          }

        }).catch(error => {
          reject(error)
        })
      })
    },
    register({
      commit,
      dispatch
    }, userInfo){
      const phone = userInfo.phone;
      const password = userInfo.password;
      const againPassword = userInfo.againPassword;
      const company = userInfo.company;
      return new Promise((resolve, reject) => {
        registerPcUser({
          phone,
          password,
          againPassword,
          company
        }).then(async res => {
          if (res.code == 200) {
            setToken(res.data.token);
            setUserId(res.data.user_id);
            setUserInfo(res.data);
            resolve({
              code: 200,
              msg: res.msg
            })
          }
          else {
            Message({ message: res.msg, type: 'error' })
          }

        }).catch(error => {
          reject(error)
        })
      })
    },
    setGlobalConfig({ commit }) {
      return new Promise((resolve, reject) => {
        if (getConfig()) {
          //存在全局数据 不重复请求
          resolve({ code: 200 })
        } else {
          getGlobalConfig().then(res => {
            if (res.code == 200) {
              setConfig(res.data);
              resolve({ code: 200 });
            } else {
              resolve({ code: 0 });
            }
          }).catch(error => {
            resolve(error)
          })
        }
  
      })
    },
    LogOut({commit}){
      return new Promise((resolve, reject) => {
        //清除所有本地存储
        localStorage.clear();
        router.push("/login");
        resolve()
      })
    },
    setCompanyName({ commit }) {
      return new Promise((resolve, reject) => {
        if (getCompany()) {
          //存在全局数据 不重复请求
          resolve({ code: 200 })
        } else {
          getCompanyName().then(res => {
            if (res.code == 200) {
              setCompany(res.data.companyName);
              resolve({ code: 200 });
            } else {
              resolve({ code: 0 });
            }
          }).catch(error => {
            resolve(error)
          })
        }
  
      })
    },
  },
  modules: {}
})